import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reamk",
  "use": "icon-reamk-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-reamk\">\n<path d=\"M3.1095 10.5155L6.141 12.2655L9.641 6.203L6.6095 4.453L3.1095 10.5155ZM2.7345 11.453L3.25 13.7655L5.5155 13.0465L2.7345 11.453ZM7.1095 3.578L10.141 5.328L11.0315 3.7965L8 2.0465L7.1095 3.578ZM1.625 11.078L7.625 0.6875L12.3905 3.4375L6.3905 13.828L2.5155 15.047L1.625 11.078ZM7.625 15.047V14.047H14.625V15.047H7.625Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol